import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBrowser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 3.75C0 2.7835 0.783501 2 1.75 2H22.25C23.2165 2 24 2.7835 24 3.75V20.25C24 21.2165 23.2165 22 22.25 22H1.75C0.783502 22 0 21.2165 0 20.25V3.75ZM1.75 3.5C1.61193 3.5 1.5 3.61193 1.5 3.75V5.5H5.5V3.5H1.75ZM7 3.5V5.5H11V3.5H7ZM12.5 3.5V5.5H22.5V3.75C22.5 3.61193 22.3881 3.5 22.25 3.5H12.5ZM22.5 7H1.5V20.25C1.5 20.3881 1.61193 20.5 1.75 20.5H22.25C22.3881 20.5 22.5 20.3881 22.5 20.25V7Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgBrowser;
